import { render, staticRenderFns } from "./devNotice.vue?vue&type=template&id=a9dff42e&scoped=true&"
import script from "./devNotice.vue?vue&type=script&lang=js&"
export * from "./devNotice.vue?vue&type=script&lang=js&"
import style0 from "./devNotice.vue?vue&type=style&index=0&id=a9dff42e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9dff42e",
  null
  
)

export default component.exports